<script setup lang="ts">
import PerformedServicesSection from '@/components/rc/miner-repairs/repairs-sidebar/miner-sidebar-sections/PerformedServicesSection.vue'
import DiagnosticsSection from '@/components/rc/miner-repairs/repairs-sidebar/miner-sidebar-sections/DiagnosticsSection.vue'
import MinerStatusSection from '@/components/rc/miner-repairs/repairs-sidebar/miner-sidebar-sections/MinerStatusSection.vue'
import RepairNotesSection from '@/components/rc/miner-repairs/repairs-sidebar/miner-sidebar-sections/RepairNotesSection.vue'
import StressTestsSection from '@/components/rc/miner-repairs/repairs-sidebar/miner-sidebar-sections/StressTestsSection.vue'
import { useMinerDetails } from '@/composables/rc/miner-details'
import { useWorkOrderDetails } from '@/composables/rc/work-order-details'
import { toRefs } from 'vue'

const props = defineProps<{ minerId: number; workOrderNumber: string }>()
const emit = defineEmits(['showAllStressTests'])

const { minerId } = toRefs(props)
const { minerDetailsQuery } = useMinerDetails(minerId)
const { data: minerDetails } = minerDetailsQuery

const { data: workOrderDetails } = useWorkOrderDetails(props.workOrderNumber)
</script>

<template>
  <el-container>
    <el-main v-if="minerDetails && workOrderDetails" class="flex flex-col gap-spacing-xl p-0 text-text-component-label">
      <PerformedServicesSection :miner-id="props.minerId" :services="workOrderDetails.scope_of_work" />
      <DiagnosticsSection :miner-id="props.minerId" />
      <MinerStatusSection :miner-id="props.minerId" />
      <StressTestsSection :miner-id="props.minerId" @show-all="emit('showAllStressTests')" />
      <RepairNotesSection :miner-id="props.minerId" />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
:deep() {
  .el-radio.is-checked {
    .el-radio__label {
      color: var(--text-component-label);
    }
  }

  .el-button {
    border-radius: var(--spacing-spacing-ss);
  }

  .el-radio-group {
    display: grid;
    grid-template-columns: 1fr;
  }

  .el-select {
    background-color: var(--fill-primary);
  }
}
</style>
